import { ruleTableRows } from "./charts";

/**
 * Mini PAR-sheet: per-rule hits, hit rate, average pay per hit, and
 * RTP contribution, joined from `rtp_per_rule` + `hits_per_rule`.
 */
export function RuleTablePanel({
  rtpPerRule,
  hitsPerRule,
  nSpins,
}: {
  rtpPerRule: Record<string, number> | null | undefined;
  hitsPerRule: Record<string, number> | null | undefined;
  nSpins: number;
}) {
  const rows = ruleTableRows(rtpPerRule, hitsPerRule, nSpins);
  return (
    <section className="border border-paper-border p-4 dark:border-term-border">
      <h2 className="text-sm font-bold uppercase tracking-widest text-paper-bright dark:text-term-bright">
        Pay rules
      </h2>
      <p className="mb-2 text-[10px] text-paper-hint dark:text-term-hint">
        per-rule hit and contribution breakdown
      </p>
      {rows.length > 0 ? (
        <div className="max-h-80 overflow-y-auto">
          <table className="w-full text-left text-xs">
            <thead>
              <tr className="text-[10px] uppercase tracking-widest text-paper-label dark:text-term-label">
                <th className="py-1 pr-2 font-semibold">Rule</th>
                <th className="py-1 pr-2 text-right font-semibold">Hits</th>
                <th className="py-1 pr-2 text-right font-semibold">Hit rate</th>
                <th className="py-1 pr-2 text-right font-semibold">Avg pay</th>
                <th className="py-1 text-right font-semibold">RTP</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-paper-border tabular-nums dark:divide-term-border">
              {rows.map((r) => (
                <tr key={r.rule}>
                  <td className="py-1 pr-2 text-paper-bright dark:text-term-bright">
                    {r.rule}
                  </td>
                  <td className="py-1 pr-2 text-right text-paper-text dark:text-term-text">
                    {r.hits.toLocaleString()}
                  </td>
                  <td className="py-1 pr-2 text-right text-paper-text dark:text-term-text">
                    {r.hitRatePct.toFixed(4)}%
                  </td>
                  <td className="py-1 pr-2 text-right text-paper-text dark:text-term-text">
                    {r.avgPay != null ? `${r.avgPay.toFixed(2)}×` : "—"}
                  </td>
                  <td className="py-1 text-right font-semibold text-emerald-700 dark:text-emerald-500">
                    {r.rtpPct.toFixed(3)}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="flex h-[120px] items-center justify-center text-xs text-paper-hint dark:text-term-hint">
          No data yet
        </div>
      )}
    </section>
  );
}
